/* eslint-disable max-len */
import { NoteContextType } from '@components/common/TagBadge/TagBadge.component'
import { TEMPLATE_CATEGORIES } from '@constants/Notes/templateCategories'
import type { QuickNoteAiMode } from './noteEditor.types'

export const DEFAULT_BACK_LABEL: Partial<Record<NoteContextType, string>> = {
  [NoteContextType.PATIENT]: 'Back to notes',
  [NoteContextType.CHARTING]: 'Back to charting',
  [NoteContextType.PERIO]: 'Back to perio',
  [NoteContextType.TREATMENT_PLAN]: 'Back to tx plan',
}

export const BUILT_IN_KEY_TO_NAME_CATEGORY = TEMPLATE_CATEGORIES.reduce(
  (acc, cat) => {
    cat.subcategories.forEach((sub) => {
      if (sub.value !== 'Custom_Add')
        acc[sub.value] = { name: sub.text, category: cat.value }
    })
    return acc
  },
  {} as Record<string, { name: string; category: string }>,
)

export const NOTES_AI_SELECT_CLINIC_TITLE =
  'Select a clinic before using AI features.'
export const NOTES_TRANSCRIPT_SUMMARY_SYSTEM_PROMPT =
  "You are EnamelAI's dental-office note assistant. Your only task is to summarize a dentist-patient visit transcript into a dental clinical note draft for staff review. This request is always in scope for the dental front desk. Do not refuse it as off-topic, even if the transcript is brief, incomplete, or light on clinical detail. Do not diagnose or invent treatment beyond what the transcript states. Return only the drafted dental note summary."
export const NOTES_TRANSCRIPT_SUMMARY_PROMPT_TEMPLATE =
  'Create a concise dental clinical note summary from this dental visit transcript. Focus on dental chief concern, oral symptoms, relevant dental findings mentioned, discussed treatment or hygiene instructions, follow-up items, and unanswered dental questions. If the transcript lacks dental details, summarize only what was said and note that dental details were not captured. Never reply that you can only help with dental-related items.'

export const QUICK_NOTE_AI_MODE_CONFIG: Record<
  QuickNoteAiMode,
  {
    icon: string
    placeholder: string
    label: string
  }
> = {
  ask: {
    icon: 'mgc_magic_3_fill',
    placeholder: 'Ask AI anything...',
    label: 'Ask AI anything',
  },
  paraphrase: {
    icon: 'mgc_pencil_2_ai_fill',
    placeholder: 'Type here to paraphrase with AI',
    label: 'Paraphrase with AI',
  },
}
